export const ONLINE_PURCHASE = {
  EN: 'Online purchase summary',
  DE: 'Zusammenfassung des Online Kaufs'
};

export const REQUESTS = {
  EN: 'Request summary',
  DE: 'Zusammenfassung der Anfrage'
};
